export default "__VITE_ASSET__Kd8$71ifBbtrQEh9PvkgvA__"